export const ProjectsData = [
    {
        "ProjectType": "Health",
        "projectTitle": "Magna",
        "projectDescription": "medical doctors, passionate about holistic and integrative medicine and wish to disrupt pharmaceutical dependency, pill-popping and short-term fixes!",
        "projectThumbnail": "https://themagnawoman.com/wp-content/uploads/2022/09/the_magna_woman.jpeg"
    },
    {
        "ProjectType": "Finance",
        "projectTitle": "Plutus",
        "projectDescription": "A chartered firm of independent financial advisers, Plutus offers clear financial planning and investment management advice.",
        "projectThumbnail": "https://plutuswealth.in/wp-content/uploads/2022/11/img02.png"
    },
    {
        "ProjectType": "Art",
        "projectTitle": "Tapi Collection",
        "projectDescription": "TAPI is a private collection in the city of Surat, a testament to the rich and colourful tapestry of India's textile and art heritage.",
        "projectThumbnail": "https://tapicollection.org/wp-content/uploads/2022/10/tapi-upcoming.jpg"
    },
    {
        "ProjectType": "Tech Repair",
        "projectTitle": "Apple Laptop Service Center",
        "projectDescription": "Apple Service Center in Mumbai",
        "projectThumbnail": "https://www.apple.com/newsroom/images/product/imac/standard/Apple-Self-Service-Mac-Repair-August-2022-hero_big.jpg.large.jpg"
    },
    {
        "ProjectType": "Creative Agency",
        "projectTitle": "The Glassbox",
        "projectDescription": "A unique ad film production workflow, compliance & analytics service.",
        "projectThumbnail": "https://theglassbox.co/wp-content/uploads/2022/03/Web-loading-newGIF.gif"
    },
]